import React from 'react';
import { filter, get, map } from 'lodash';

// import Icons from '@/icons';
// import { ICONS } from '@/constants/icons.constants';

import './DashboardTable.scss';
import SvgList from '../SvgList';

const DashboardTable = (props) => {
  const { type, data } = props;

  return (
    <div className={'DashboardTable'}>
      <div className={'header'}>
        <div className={'heading1'}>
          <p className={'maintitle'}>{type === 'down' ? 'Most Dislike songs' : 'Most Liked songs'}</p>

          <SvgList name={type === 'down' ? 'decreasing-icon' : 'raising-icon'} />
        </div>
        <div className={'header2'}>
          <p className={'view'}>Views</p>
          <p className={'like'}>{type === 'down' ? 'Dislikes' : 'Likes'}</p>
        </div>
      </div>

      <div className="rows" style={{ flex: 1 }}>
        {filter(data?.topDislikedSongs, (item) => item.total_dislikes > 0)?.length > 0 ? (
          map(
            filter(data.topDislikedSongs, (item) => item.total_dislikes > 0),
            (item, index) => (
              <div className={'row'} key={index}>
                <div className={'heading1'}>
                  <div className={'iconText'}>
                    {item.thumbnail_img ? (
                      <img
                        src={`${process.env.REACT_APP_MEDIA_URL}/${get(item, 'thumbnail_img', '')}`}
                        alt="thumbnail"
                        className={'image'}
                      />
                    ) : (
                      <div className={'songName'}>{item.title[0]}</div>
                    )}
                  </div>
                  <p className={'dashboardtitle'}>{item.title}</p>
                </div>
                <div className={'header2'}>
                  <p className={'view1'}>{item.total_views}</p>
                  <p className={'like1'}>{item.total_dislikes}</p>
                </div>
              </div>
            )
          )
        ) : (
          <div
            className="no-data"
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}
          >
            <SvgList name="no-data-icon" />
            <p style={{ marginTop: '8px' }}>No Data to show.</p>
          </div>
        )}
      </div>

      {/* <div className={'rows'}>
        {type === 'down'
          ? map(get(data, 'topDislikedSongs'), (item, index) => (
              <div className={'row'}>
                <div className={'heading1'}>
                  <div className={'iconText'}>
                    {item.thumbnail_img ? (
                      <img
                        src={`https://s3.amazonaws.com/4-play-2.0-bucket/${get(item, 'thumbnail_img', '')}`}
                        alt="thumbnail"
                        className={'image'}
                      />
                    ) : (
                      <div className={'songName'}>{item.title[0]}</div>
                    )}
                  </div>
                  <p className={'dashboardtitle'}>{item.title}</p>
                </div>
                <div className={'header2'}>
                  <p className={'view1'}>{item.total_views}</p>
                  <p className={'like1'}>{item.total_dislikes}</p>
                </div>
              </div>
            ))
          : map(get(data, 'topLikedSongs'), (item, index) => (
              <div className={'row'}>
                <div className={'heading1'}>
                  <div className={'iconText'}>
                    {item.thumbnail_img ? (
                      <img
                        src={`https://s3.amazonaws.com/4-play-2.0-bucket/${get(item, 'thumbnail_img', '')}`}
                        alt="thumbnail"
                        className={'image'}
                      />
                    ) : (
                      <div className={'songName'}>{item.title[0]}</div>
                    )}
                  </div>
                  <p className={'dashboardtitle'}>{item.title}</p>
                </div>
                <div className={'header2'}>
                  <p className={'view1'}>{item.total_views}</p>
                  <p className={'like1'}>{item.total_likes}</p>
                </div>
              </div>
            ))}
      </div> */}
    </div>
  );
};

export default DashboardTable;

